<template>
    <AppHeaderDropdown right no-caret v-b-tooltip="profile.email">
        <template slot="header">
            <b-spinner v-if="profileLoading"></b-spinner>
            <template v-else>
                <div class="avatar" :style="{ backgroundColor: getProfileAvatarColor }">
                    <div class="avatar__icon">
                        <img :src="profileAvatarUrl" class="img-avatar" alt="My Account"/>
                    </div>
                    <div class="avatar__letters">
                        {{ getProfileAvatarLetters }}
                    </div>
                </div>
<!--                <img :src="profileAvatarUrl" class="img-avatar" alt="My Account" v-b-tooltip="profile.email"/>-->
            </template>
        </template>
        <template slot="dropdown">
            <b-dropdown-header class="text-center">
                <div class="font-weight-bold">{{ profile.name }}</div>
                <div><small class="text-muted">UI: <strong>{{ ui_version }}</strong></small></div>
                <div><small class="text-muted">API: <strong>{{ profile.api_version }}</strong></small></div>
            </b-dropdown-header>
            <b-dropdown-item href="/profile/view" target="_blank">
                <i class="fa-solid fa-user"></i> Profile
            </b-dropdown-item>
            <b-dropdown-item href="/profile/settings" target="_blank">
                <i class="fa-solid fa-wrench"></i> Settings
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item @click="exitMasquerade" v-if="isMasquerade">
                <i class="fa-duotone fa-masks-theater"></i> End Masquerade
            </b-dropdown-item>
            <b-dropdown-item :to="{name: 'logout'}">
                <i class="fa-solid fa-lock"></i> Logout
            </b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
    import {AUTH_RETURNAS} from '../store/actions';
    import {HeaderDropdown as AppHeaderDropdown} from '@coreui/vue';
    import md5 from 'md5';
    import ColorHash from 'color-hash';

    export default {
        name: 'HeaderDropdownAccount',
        components: {
            AppHeaderDropdown,
        },
        data() {
            return {
                isMasquerade: false,
                profileLoading: true,
                profileAvatarUrl: null,
                ui_version: process.env.VUE_APP_VERSION,
            };
        },
        mounted() {
            this.getProfileAvatarUrl();
        },
        methods: {
            getProfileAvatarUrl() {
                if (this.$store.getters.isProfileLoaded) {
                    if (this.profile && this.profile.email) {
                        this.isMasquerade = !!this.profile.original_user;
                        this.profileLoading = false;
                        this.profileAvatarUrl = 'https://www.gravatar.com/avatar/' + md5(this.$store.getters.getProfile.email) + '?d=mp';
                    }
                }
            },
            exitMasquerade() {
                this.$store.dispatch(AUTH_RETURNAS).then(() => {
                    this.$store.commit('FORCE_CACHE_BUST');
                    //full page reloaded needed to reset some minor elements
                    window.location.href = window.location.origin + "/dashboard";
                    //vm.$router.push({name: 'home'});
                    //vm.$router.go(0);
                }).catch((err) => {
                    console.log("ERROR", err);
                });
            }
        },
        computed: {
            profile: function () {
                return this.$store.getters.getProfile;
            },
            getProfileAvatarColor() {
                //return '#' + md5(this.$store.getters.getProfile.email).toString().substr(0,6);
                var colorHash = new ColorHash({saturation: 0.8, lightness: 0.4});
                return colorHash.hex(this.$store.getters.getProfile.email);
            },
            getProfileAvatarLetters() {
                return this.$store.getters.getProfile.name.toString()
                    .split(' ')
                    .map(word => word[0])
                    .join('');
                    // .substr(0,2);
            },
        },
        watch: {
            profile: function() {
                this.getProfileAvatarUrl();
            },
        }
    };
</script>

<style scoped>
.avatar {
    /* Center the content */
    display: inline-block;
    vertical-align: middle;

    /* Used to position the content */
    position: relative;
    z-index: -1;

    /* Colors */
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;

    /* Rounded border */
    border-radius: 50%;
    height: 35px;
    width: 35px;

    margin: 0 10px;
}

.avatar__letters, .avatar__icon {
    /* Center the content */
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
    line-height: 0;
}

.avatar__letters {
    /*text-shadow: #2a2c36 0px 0px 4px;*/
}

.avatar__icon {
    opacity: 0.5;
    height: 100%;
    width: 100%;
}
</style>
